import { css } from "lit";

export const globalStyles = css`
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  @tailwind variants;
  a {
    color: #0f71bb;
    text-decoration-line: underline;
    text-underline-offset: 4px;
    cursor: pointer;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
  }
  p {
    color: #344054;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  strong {
    font-size: 14px;
    line-height: 24px;
  }
`;
